export const DEFAULT_EFFECTIVE_DAYS = 18;

const toFiniteNumber = (value) => {
  if (value === "" || value === null || value === undefined) {
    return null;
  }

  if (typeof value === "number") {
    return Number.isFinite(value) ? value : null;
  }

  const normalized = String(value).trim().replace(/\s+/g, "").replace(/,/g, ".");
  if (!normalized) {
    return null;
  }

  const numericValue = Number.parseFloat(normalized);
  return Number.isFinite(numericValue) ? numericValue : null;
};

export const effectiveDays = (declared, forecast) => {
  const declaredValue = toFiniteNumber(declared);
  if (declaredValue !== null && declaredValue >= 0) {
    return declaredValue;
  }

  const forecastValue = toFiniteNumber(forecast);
  if (forecastValue !== null && forecastValue >= 0) {
    return forecastValue;
  }

  return DEFAULT_EFFECTIVE_DAYS;
};

export const resolveMissionTimesheetFallbackDays = (mission) =>
  effectiveDays(null, mission?.days_per_month);
